import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './constants';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

const MOBILE_DEVICE_INJECT_IMAGE = createApiNamespacedConstants('MOBILE_DEVICE_INJECT_IMAGE');

export default {
  MOBILE_DEVICE_INJECT_IMAGE,
};
